import { render, staticRenderFns } from "./AssayViewControls.vue?vue&type=template&id=1fd44bcc&scoped=true"
import script from "./AssayViewControls.vue?vue&type=script&setup=true&lang=ts"
export * from "./AssayViewControls.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AssayViewControls.vue?vue&type=style&index=0&id=1fd44bcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd44bcc",
  null
  
)

export default component.exports